import React, { useEffect } from "react"
import { AppPillToggle } from "@components"
import { useReportMultipleModalMultipleEdit } from "Pages/ReportsAlerts/Reports/@hooks"
import { useManualExecution } from "Pages/ReportsAlerts/Reports/@signals"

const MANUAL = 'manual'
const SCHEDULED = 'scheduled'


// Same manual-execution flag as before, as a two-option selector
export default function ReportManualExecutionSwitch() {

	const {
		data,
		setFrequency
	} = useReportMultipleModalMultipleEdit("manuallyExecution")

	useEffect(() => {
		useManualExecution.value = data
	}, [data])

	return <AppPillToggle
		aria-label="How the reports run"
		size="small"
		value={data ? MANUAL : SCHEDULED}
		options={[{ value: SCHEDULED, label: 'Scheduled' }, { value: MANUAL, label: 'Manual execution' }]}
		onChange={option => setFrequency(option === MANUAL)}
	/>
}
